import { render, staticRenderFns } from "./ExcludeItemBody.vue?vue&type=template&id=39fe41cc&scoped=true"
import script from "./ExcludeItemBody.vue?vue&type=script&lang=ts"
export * from "./ExcludeItemBody.vue?vue&type=script&lang=ts"
import style0 from "./ExcludeItemBody.vue?vue&type=style&index=0&id=39fe41cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fe41cc",
  null
  
)

export default component.exports